var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcArrowdown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10px",
    height: "14px",
    viewBox: "0 0 10 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/ic-arrow down") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Components",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(-45.000000, -328.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(40.396766, 325.087406)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Background",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.75,3.64510879 L10.7493496,14.0371088 L13.5909903,11.1973262 L14.6516504,12.2579863 L11.2113496,15.6971088 L10.7493496,16.1651088 L10.75,16.227656 L10.6883496,16.2271088 L10,16.9268186 L9.30934957,16.2271088 L9.25,16.227656 L9.24934957,16.1661088 L8.71134957,15.6211088 L5.34834957,12.2579863 L6.40900974,11.1973262 L9.24934957,14.0371088 L9.25,3.64510879 L10.75,3.64510879 Z",
    id: "Combined-Shape",
    fill: "currentColor"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArrowdown);
export default __webpack_public_path__ + "static/media/ic-arrow down.b37e65fa.svg";
export { ForwardRef as ReactComponent };